export default "__VITE_ASSET__8Aj$wPdG__"